const initStickyBtn = () => {
	const btn = document.getElementById('stickyBtn');
	if( btn ){
		document.addEventListener('scroll', () => {
			btn.classList.toggle('active', (document.documentElement.scrollTop < 150) )
		});
	}
}

export default initStickyBtn;